








































import AbpBase from "../../../lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import { saveAs } from "file-saver";
import util from "../../../lib/util";
import model from "./model.vue";
import tabTitle from "./title.vue";
import importData from "./importData.vue";
import {
    DeleteTabTempTitle,
    ExportReportTab,
    GetTabTemps,
    GetTabTempsByType
} from "../../../api/systemBasic";
@Component({
  components: { model, tabTitle,  importData },
})
export default class extends AbpBase {
    QueryString = "";
    list: any = [];
    detailList: any = [];
    dataShow = false;
    titleShow = false;
    modelData: any = {};
    loading = false;
    table: any = {
        loading: false,
        detailLoading: false,
    };
    detailInfo: any = {};
    modelShow = false;
    importShow = false;
    column = [
        {
        type: "selection",
        width: 60,
        align: "center",
        },
        {
        title: "名称",
        key: "name",
        },
    ];
    detailColumn = [
        {
        title: "名称",
        key: "name",
        },
        {
        title: "序号",
        key: "orderBy",
        },
        {
        title: "操作",
        width: 180,
        render: (h1: any, params: any) => {
            const h = this.$createElement;
            let isdefaultDom: any;
            return h("div", [
            isdefaultDom,
            h(
                "Button",
                {
                props: {
                    type: "primary",
                    size: "small",
                },
                style: {
                    marginRight: "15px",
                },
                on: {
                    click: () => {
                    this.edit(params.row);
                    },
                },
                },
                "编辑"
            ),
            h(
                "Button",
                {
                props: { type: "error", size: "small" },
                on: {
                    click: () => {
                    this.del(params.row);
                    },
                },
                },
                "删除"
            ),
            ]);
        },
        },
    ];
    get tableHeight() {
        return window.innerHeight - 220;
    }
    created() {
        this.getData();
    }
    async getData() {
        console.log(this.$route.meta.title);
        this.table.loading = true;
        this.dataShow = false;
        let res = await GetTabTemps({ QueryString: this.QueryString });
        this.list = res.objects;
        this.table.loading = false;
        this.titleShow = false;
    }
    async getDetail(row: any) {
        let res = await GetTabTempsByType({ id: row.id });
        this.detailList = res.objects;
    }
    //tab选择
    tabChange(currentRow: any, oldCurrentRow: any) {
        if (currentRow) {
            this.detailInfo = currentRow;
            this.getDetail(currentRow);
            this.dataShow = true;
        }
    }
    addTitle() {
        this.titleShow = true;
    }
    add() {
        this.modelData.title = "新增";
        this.modelData.info = this.detailInfo;
        this.modelData.row = {};
        this.modelShow = true;
    }
    edit(row: any) {
        this.modelData.title = "编辑";
        this.modelData.info = this.detailInfo;
        this.modelData.row = row;
        this.modelShow = true;
    }
    async del(row: any) {
        this.$Modal.confirm({
        title: "提示",
        content: "此操作将永久删除该记录, 是否继续?",
        onOk: async () => {
            let res = await DeleteTabTempTitle({ Id: row.id });
            this.getDetail(this.detailInfo);
        },
        });
    }
    async exportData() {
        let filterCheck = (this.$refs.tabList as any).getSelection();
        if (filterCheck.length == 0) {
        this.$Message.warning("请勾选要导出的Tab数据");
        return false;
        }
        let payload = { idList: filterCheck.map((x) => x.id) };
        this.loading = true;
        let res = await ExportReportTab(payload);
        this.loading = false;
        if (res.status == 1) {
        window.open(`${XMLHTTP_BASEURL}/${res.objects}`);
        }
    }
    importData() {
        this.importShow = true;
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/tabMaintain/index.vue